export default __webpack_public_path__ + "static/181-ba32218d30d8b0dddeff6aaa26dec086.gif";